export default function validarDataNascimento(valor: string) {
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) return false;

  const [dia, mes, ano] = valor.split('/').map(Number);

  if (mes < 1 || mes > 12 || dia < 1 || dia > 31) return false;

  const dataNascimento = new Date(ano, mes - 1, dia);
  if (
    dataNascimento.getDate() !== dia ||
    dataNascimento.getMonth() + 1 !== mes ||
    dataNascimento.getFullYear() !== ano
  ) {
    return false;
  }

  const hoje = new Date();
  const idadeMinima = new Date(
    hoje.getFullYear() - 18,
    hoje.getMonth(),
    hoje.getDate(),
  );

  return dataNascimento <= idadeMinima;
}
